export default function TittleCard(props) {
  const { title } = props;

  return (
    <div className="title-card-container">
      <span>{title}</span>
    </div>
  );
}
